// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getAnalytics } from "firebase/analytics";

// Your web app's Firebase configuration
const firebaseConfig = {
    apiKey: "AIzaSyAPNvP8XUFQTZPVNtQySXb-Tsda56S0Be0",
    authDomain: "astro-hub-2cf08.firebaseapp.com",
    projectId: "astro-hub-2cf08",
    storageBucket: "astro-hub-2cf08.firebasestorage.app",
    messagingSenderId: "587371555354",
    appId: "1:587371555354:web:1e211f5e6372efadea3fa3",
    measurementId: "G-S948LDNS8T"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

// Initialize services
export const db = getFirestore(app);
export const auth = getAuth(app);